module.exports = __webpack_public_path__ + "static/media/hero2.cf69fa4e.png";